import { Controller } from '@hotwired/stimulus'
import autoComplete from '@tarekraafat/autocomplete.js'

// Connects to data-controller="location-field"
export default class extends Controller {
  static targets = ['input', 'output']

  connect () {
    this.session = Math.random().toString(36).substring(2)

    new autoComplete({
      selector: '*[data-location-field-target="input"]',
      data: {
        src: async (query) => {
          try {
            const source = await fetch(`/locations?q=${query}&session=${this.session}`)
            return await source.json()
          } catch (error) {}
        },
        keys: ['name']
      },
      debounce: 500,
      threshold: 3,
      resultsList: {
        element: (list, data) => {
          if (!data.results.length) {
            const message = document.createElement('li')
            message.className = 'no_result'
            message.innerHTML = `Brak wyników`
            list.prepend(message)
          }
        },
        noResults: true,
      }
    })

    this.inputTarget.addEventListener('selection', (event) => {
      this.inputTarget.value = event.detail.selection.value.name
      this.outputTarget.value = event.detail.selection.value.id
    })

    this.inputTarget.addEventListener('focus', () => {
      this.inputTarget.value = ''
      this.outputTarget.value = ''
    })

    this.inputTarget.addEventListener('blur', () => {
      if (!this.outputTarget.value) {
        this.inputTarget.value = ''
      }
    })
  }
}
